import { useCallback } from 'react';
import crfDcfService from '../../../services/crfDcfService';

/** Thin wrapper around {@link crfDcfService} for hooks / components. */
export function useCrfDcfApi() {
  const raise = useCallback((body) => crfDcfService.raise(body), []);
  const submitAllToCra = useCallback((nCRFHdrNo) => crfDcfService.submitAllToCra(nCRFHdrNo), []);
  const resolve = useCallback((nCRFDtlNo, body) => crfDcfService.resolve(nCRFDtlNo, body), []);
  const close = useCallback((nCRFDtlNo, body) => crfDcfService.close(nCRFDtlNo, body), []);
  const history = useCallback((nCRFDtlNo) => crfDcfService.history(nCRFDtlNo), []);
  const pageState = useCallback((nCRFHdrNo) => crfDcfService.pageState(nCRFHdrNo), []);
  return { raise, submitAllToCra, resolve, close, history, pageState };
}
